import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommunityConfigService } from '../util';
import { SelectionFile } from '../../interfaces/selection';

@Injectable({ providedIn: 'root' })
export class FileService {
  #http = inject(HttpClient);
  #config = inject(CommunityConfigService);

  get #filesUrl(): string {
    return this.#config.internalApi.filesUrl!;
  }

  upload(file: File, relation: string): Observable<SelectionFile> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('relation', relation);
    return this.#http.post<SelectionFile>(`${this.#filesUrl}/`, formData);
  }
}
